<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- RESERVED -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Watch Later</span>
                </div>
              </b-col>
              <b-col cols="12">
                  <span class="txt-section-subtitle red">Classes: {{classes.length}}</span>
              </b-col>
            </b-row>
          </div>

          <!-- TBD classList component. -->
          <div class="div-section-body">
            <b-row v-if="rows === 0">
              <b-col class="pt-3 pb-3 pl-4 pr-4">
                Your watch later list is empty. Add to this list by tapping the + button after selecting a webinar or product video.
              </b-col>
            </b-row>
            <b-row v-for="(row) in classes" ref="rows" v-bind:key="row.classId" class="mt-3 mb-3 pointer" @click.stop.prevent="gotoClass(row.hash)">
              <b-col cols="4">
                <!-- {{row.classId}} -->
                  <div class="text-center">
                    <b-img fluid v-bind:src="row.photo" />
                    <queuebutton :c="row.hash" :s="studentHash" q="1" @remove-class="removeClass"></queuebutton>
                  </div>
              </b-col>
              <b-col cols="8" style="margin-left: -20px;">
                <div class="class-title">{{row.className}}</div>
                <div v-if="row.credits !== 0" class="class-details">
                  {{row.speakerName}}
                  <br>{{row.sponsorCompanyName}}
                  <br>{{row.releaseDate | prettyDate}} - {{row.credits}} CEU ({{row.creditName}})
                </div>
                <div v-if="row.credits === 0" class="class-details">
                  {{row.sponsorCompanyName}}
                  <br>{{row.releaseDate | prettyDate}}
                </div>
              </b-col>
            </b-row>

            <b-row v-if="pages > 1" class="mt-4">
              <b-col>
                <b-pagination align="center" v-model="curPage" :total-rows="totalRows" :per-page="pageSize" @change="pageChange" @input="pageInput"></b-pagination>
              </b-col>
            </b-row>

          </div>
        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils";

var data = {
  debug: false,
  error: false,
  loading: true,
  busy: false,
  studentHash: '',
  msg: "Watch Later",
  blurb: "",
  classes: [],
  removed: [],
  totalRows: 0,
  pageSize: 0,
  pages: 0,
  curPage: 1,
  bannerAds: []
};

export default {
  name: "Queue",
  data() {
    return data;
  },
  props: {
    page: {
      type:String,
      required: false,
      default: "1"
    }
  },
  computed: {
    rows () {
      return this.classes.length
    }
  },
  methods: {
    pageInput(page) {
      // console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doQueue()
      // console.log(`pageChange: ${page}`)
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '/queue' : `/queue/${pageNum-1}`
    },
    setCurPage() {
      try {
        this.curPage = parseInt(this.page)
        if (this.curPage <= 0) this.curPage = 1
      }
      catch(e) {
        this.curPage = 1
      }
      // console.log( `this.page: ${this.page}  curPage: ${this.curPage}`)
    },
    gotoClass(hash) {
      this.$router.push(`/classroom/${hash}`)
    },
    removeClass(hash) {
      this.classes = this.classes.filter( row => row.hash != hash )
      this.totalRows = this.classes.length  // calibrate
    },
    doQueue() {
      this.loading = true
      this.classes = []
      service
        .getQueue(this.studentHash, this.curPage-1)
        .then(res => {
          if (this.debug) console.log(res)
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Queue: ${res.rowCount}`
            this.classes = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = (res.pageSize) ? Math.ceil( this.totalRows/res.pageSize ): 0
            if (this.curPage > this.pages) this.curPage = this.pages

          } else {
            this.blurb = "Training queue is empty.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e));
    }
  },
  created() {
    this.studentHash = this.$root.getToken();
    this.doQueue()
  },
  mounted() {
    // console.log('mounted')
  },
  beforeDestroy() {
    // console.log('destroy')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Queue.vue